<ng-scrollbar style="height: calc(100vh - 88px)" visibility="hover">
  @if (showContent) {
  @if (sysCode != '12') {
  <app-main-details [userName]="userName" [userRole]="userRole" [profileImage]="profileImage"
    [userCompany]="userCompany" />
  } @else {
  <app-self-services-details [empDetails]="empDetails" [profileImage]="profileImage"></app-self-services-details>
  }
  }
  <div class="navbar-content">
    <ul class="nav coded-inner-navbar" (click)="fireOutClick()">
      @for (item of menus; track item.id) {
      @if (item.type === 'group') {
      <app-menu-group-vertical [item]="item"></app-menu-group-vertical>
      } @else if (item.type === 'collapse') {
      <app-menu-collapse [item]="item"></app-menu-collapse>
      } @else if (item.type === 'item') {
      <app-menu-item [item]="item"></app-menu-item>
      }
      }
    </ul>
  </div>
</ng-scrollbar>